import { AbstractControl } from '@angular/forms';
import * as _ from 'lodash';
import { isArray } from 'util';

export class CustomValidators {
    public static isInEnum(allowedEnum: { [s: number]: string }, message: string) {
        return CustomValidators.isInArray(Object.values(allowedEnum), message);
    }

    public static isInArray(values: any[], message: string) {
        const valuesSet = new Set(values);

        return (control: AbstractControl): { [key: string]: any } => {
            const error = {};
            error[message] = true;

            return (!valuesSet.has(control.value)) ? error : undefined;
        };
    }

    public static requiredWithCustomMessage(message: string) {
        return (control: AbstractControl): { [key: string]: any } => {
            const error = {};
            error[message] = true;

            return _.isEmpty(control.value) ? error : undefined;
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/customValidators.ts